module.exports = __webpack_public_path__ + "static/media/product3.07b256f0.jpg";